/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppState
 */
export interface AppState {
    /**
     * 
     * @type {string}
     * @memberof AppState
     */
    version: string;
    /**
     * 
     * @type {number}
     * @memberof AppState
     */
    jobs: number;
    /**
     * 
     * @type {number}
     * @memberof AppState
     */
    visitors?: number;
}

/**
 * Check if a given object implements the AppState interface.
 */
export function instanceOfAppState(value: object): value is AppState {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('jobs' in value) || value['jobs'] === undefined) return false;
    return true;
}

export function AppStateFromJSON(json: any): AppState {
    return AppStateFromJSONTyped(json, false);
}

export function AppStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppState {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'jobs': json['jobs'],
        'visitors': json['visitors'] == null ? undefined : json['visitors'],
    };
}

export function AppStateToJSON(json: any): AppState {
    return AppStateToJSONTyped(json, false);
}

export function AppStateToJSONTyped(value?: AppState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'jobs': value['jobs'],
        'visitors': value['visitors'],
    };
}

